import TextContent from '@/components/HighlightMediaText/TextContent/TextContent';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';

import type { HighlightMediaTextProps } from './HighlightMediaTextFull';
import useStyles from './HighlightMediaTextFull.styles';

const InnerContent = ({
  isOnDark,
  isRightAligned,
  subhead,
  cta,
  features,
  isHeroMode,
  eyebrow,
  headline,
  ...props
}: HighlightMediaTextProps) => {
  const { classes } = useStyles({ isOnDark });

  return (
    <GridContainer
      fixed
      gridProps={{
        className: classes.fullSectionHeader,
        style: { justifyContent: isRightAligned ? 'flex-end' : 'flex-start' },
      }}
    >
      <TextContent
        subhead={subhead}
        features={features}
        cta={cta}
        isHeroMode={isHeroMode}
        eyebrow={eyebrow}
        headline={headline}
        isOnDark={isOnDark}
        {...props}
      />
    </GridContainer>
  );
};

export default InnerContent;
